import { Injectable, OnInit } from '@angular/core';
import { IAuth, IAuthDispositivo, Usuario } from '../interfaces/book.interface';
import { LoadingController, NavController } from '@ionic/angular';
import { AuthService } from './auth.service';
import { ToastService } from './toast.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AlertService } from './alert.service';
import { Subscription, throwError } from 'rxjs';
import { DivisasService } from './divisas.service';

@Injectable({
    providedIn: 'root'
})
export class RedatwaterService {

    private subscriptionHttp: Subscription = new Subscription();
    private subscriptionHttpAgregarPanel: Subscription = new Subscription();
    private subscriptionHttpCheckTokenApp: Subscription = new Subscription();

    public webUrl = 'https://bancodelagua.com/app';
    public apiUrl = 'https://api.bancodelagua.com/channel'; // Canal de comunicacion
    private httpHeaders: any;

    idRoot = 'c65a0da4b357b83677f25803684f5a90'; // Red AT-WATER Banco del Agua

    paisSeleccionado: any = {
        id: 1,
        indicativo_movil: 57,
        pais: 'colombia',
        divisa: 'COP',
        idioma: 'es',
        continente: '',
        precio_litro_agua: '',
        img: 'assets/img/paises/1.png'
    };

    paisBase: any = {
        id: 1,
        pais: 'colombia',
        divisa: 'COP',
        idioma: 'es',
        img: 'assets/img/paises/1.png'
    };

    peticionDatosAPI = '';

    ciudades: any;

    authUsuario: IAuth = null;
    authDispositivo: IAuthDispositivo = null;
    usuarioData: any = null;

    // APP CONFIG
    key_empresa = '';
    key_sistema = '';
    modelo_sistema = '';

    channelMessage: any = [];
    channelFullMessages: any = [];

    limiteCacheMessages: number = 1000;

    constructor(
        private http: HttpClient,
        private loadingCtrl: LoadingController,
        private alertController: AlertService,
        private auth: AuthService,
        private toast: ToastService,
        private divisas: DivisasService,
        private navCtrl: NavController
    ) {
        //console.log('Canal de comunicacion Red AT-WATER...');

        this.auth.loadAppConfig().then((appData: any) => {
            if (appData?.pais) {
                // console.log('Sesion de App Config -> ', appData);
                this.setPaisSeleccionado(appData.pais);
            } else {
                console.log('Seguimiento de errores -> ', appData);
            }
        }).catch((err: any) => {
            console.log('Seguimiento de errores -> ', err);
        });

        this.peticionDatosAPI = '?pass=' + this.idRoot + '&pais=' + this.getPaisSeleccionado().id + '&aquabot=2&tipo_app=atwater';

    }

    setChannelMessages(msg: any) {
        if (msg) {

            this.channelMessage = msg;
            this.channelMessage.tipo = 'redatwater';
            this.channelMessage.fecha = Date.now();

            if (this.channelFullMessages.length >= this.limiteCacheMessages) {
                this.channelFullMessages = [];
                // console.log('Seguimiento -> Limpiando memoria cache de mensajes...');
            }
            this.channelFullMessages.push(this.channelMessage);
        }
    }

    getChannelMessage() {
        return this.channelMessage;
    }

    getFullMensajes() {
        return this.channelFullMessages;
    }

    getWebUrl() {
        return this.webUrl;
    }

    async loadAuthDispositivo(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.authDispositivo) {
                resolve(this.authDispositivo);
            } else {
                resolve(false);
            }
        });
    }

    async loadInfoSistema(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.usuarioData) {
                resolve(this.usuarioData);
            } else {

                resolve(false);
            }
        });
    }


    getPaisBase() {
        return this.paisBase;
    }

    // Verificar Token App
    async authTokenApp(auth: any): Promise<any> {
        return new Promise((resolve, reject) => {
            if (auth?.id) {
                this.checkTokenApp(auth).then((tokenApp: any) => {
                    if (tokenApp) {
                        //console.log('Token App -> Verificado! ' + JSON.stringify(tokenApp));
                        resolve(tokenApp);
                    } else {
                        console.log('Seguimiento de errores -> Cerrando sesion... ');
                        this.navCtrl?.navigateRoot(['/logout']);
                        //resolve(false);
                    }
                }).catch(error => {
                    console.log('Seguimiento de errores -> Error verificar token App. ' + error);
                    resolve(error);
                });
            } else {
                resolve(false);
            }
        });
    }

    async getFullConexionSistema(dispositivo_id: string) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        //loading.present();

        const apiPath = this.apiUrl + '/redatwater/getFullConexionSistema' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id
        }

        // console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    // console.log('Peticion -> Full conexion sistema: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData?.channel_app[0]) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> ');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    // loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    //loading.dismiss();
                })
            );

        });
    }

    // Registro de usuario
    async getRegistroUsuario(usuario: any, dispositivo_id: any): Promise<any> {
        const loading = await this.loadingCtrl.create({
            message: 'Procesando registro...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        //console.log('Usuario ->' + usuario);
        //console.log('Tarjeta ->' + tarjeta);
        // EXTERNO
        //console.log('Referido ->' + referido);
        //console.log('Cupon ->' + cupon);
        //console.log('Ticket ->' + ticket);

        const apiPath = this.apiUrl + '/redatwater/registroUsuario' + this.peticionDatosAPI;
        const parametrosPeticion = {
            us: {
                perfil_tipo_cuenta: usuario.tipo_cuenta,
                perfil_nombres: usuario.nombres,
                perfil_apellidos: usuario.apellidos,
                perfil_email: usuario.email,
                perfil_tipo_documento_id: usuario.tipo_documento_id,
                perfil_numero_documento: usuario.numero_documento,
                perfil_ciudad: usuario.ciudad,
                perfil_direccion: usuario.direccion,
                perfil_sexo: usuario.sexo,
                perfil_celular: usuario.celular,
                perfil_tipo_relacion: usuario.tipo_relacion,
                perfil_texto_relacion: usuario.texto_relacion
            },
            ta: {
                clave: usuario.tarjeta_clave,
            }
        }

        // console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();

            this.httpHeaders = this.httpHeaders.append('dispositivo_id', dispositivo_id);

            this.httpHeaders = this.httpHeaders.append('perfil_tipo_cuenta', parametrosPeticion.us.perfil_tipo_cuenta);
            this.httpHeaders = this.httpHeaders.append('perfil_nombres', parametrosPeticion.us.perfil_nombres);
            this.httpHeaders = this.httpHeaders.append('perfil_apellidos', parametrosPeticion.us.perfil_apellidos);
            this.httpHeaders = this.httpHeaders.append('perfil_email', parametrosPeticion.us.perfil_email);
            this.httpHeaders = this.httpHeaders.append('perfil_tipo_documento', parametrosPeticion.us.perfil_tipo_documento_id);
            this.httpHeaders = this.httpHeaders.append('perfil_numero_documento', parametrosPeticion.us.perfil_numero_documento);
            this.httpHeaders = this.httpHeaders.append('perfil_sexo', parametrosPeticion.us.perfil_sexo);
            this.httpHeaders = this.httpHeaders.append('perfil_ciudad', parametrosPeticion.us.perfil_ciudad);
            this.httpHeaders = this.httpHeaders.append('perfil_celular', parametrosPeticion.us.perfil_celular);
            this.httpHeaders = this.httpHeaders.append('perfil_direccion', parametrosPeticion.us.perfil_direccion);
            this.httpHeaders = this.httpHeaders.append('perfil_tipo_relacion', parametrosPeticion.us.perfil_tipo_relacion);
            this.httpHeaders = this.httpHeaders.append('perfil_texto_relacion', parametrosPeticion.us.perfil_texto_relacion);


            this.httpHeaders = this.httpHeaders.append('tarjeta_clave', parametrosPeticion.ta.clave);

            const addUsuario = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((data: any) => {

                    // console.log('Peticion -> Registro de usuario: ', data);
                    if (data) {
                        if (data.respuesta) {
                            if (data.respuesta.data) {
                                if (data.respuesta.data.msg) {
                                    const messages = data.respuesta.data.msg;
                                    this.setChannelMessages(messages);
                                    this.toast.msgAppMultiple(messages, 'bottom');
                                }
                                resolve(data.respuesta.data);
                            } else {
                                resolve(false);
                            }
                        }
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                })
            );

        });

    }

    async listaCiudades(pais: any): Promise<any> {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando ciudades...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        return new Promise((resolve, reject) => {
            /** 
             * En este caso, obtengo el resultado de otra función para usarlo
             * dentro del cuerpo de mi promesa
             */


            const parametrosPeticion = {
                pais: pais
            }

            const apiPath = this.apiUrl + '/redatwater/getListaCiudades' + this.peticionDatosAPI;
            //this.httpHeaders = this.httpHeaders.append('pais', parametrosPeticion.pais);
            this.ciudades = this.subscriptionHttp.add(
                this.http.get(apiPath).subscribe((data: any) => {
                    if (data) {

                        if (data.respuesta.data.msg) {
                            const messages = data.respuesta.data.msg;
                            this.setChannelMessages(messages);
                            this.toast.msgAppMultiple(messages, 'bottom');
                        }

                        console.log('Peticion -> lista de ciudades: ', data);
                        // Lista de ciudades 
                        this.ciudades = data.respuesta.data.lista;
                        //console.log('Listado de ciudad -> ' + this.ciudades);

                        if (this.ciudades) {

                            resolve(this.ciudades);
                        } else {
                            resolve(false);
                        }
                    }
                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                })
            );
        });
    }

    // PubliAqua Videos Youtube Full Anuncios
    //https://redatwater.com/channel/bancodelagua/getPubliaquaFullPublicaciones?pass=&empresa=&pais=
    async consultarAnunciosFullYoutube(): Promise<any> {
        const loading = await this.loadingCtrl.create({
            message: 'Cargando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        return new Promise((resolve, reject) => {

            const apiPath = this.apiUrl + '/redatwater/getPubliaquaFullYoutubePublicaciones' + this.peticionDatosAPI;
            const listaAnuncios = this.subscriptionHttp.add(
                this.http.get(apiPath).subscribe((data: any) => {
                    //console.log('Peticion -> Full Anuncios PubliAqua: ', data);

                    if (data) {
                        if (data.respuesta.data.msg) {
                            const messages = data.respuesta.data.msg;
                            this.setChannelMessages(messages);
                            //this.toast.msgAppMultiple(messages, 'bottom');
                        }
                        if (data.respuesta.data.publiaqua) {

                            resolve(data.respuesta.data.publiaqua);
                        } else {
                            resolve(false);
                        }
                    }
                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                })
            );

        });
    }

    async dispositivoAuth(codigo: any, sistema: any) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando sistema ...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater/login' + this.peticionDatosAPI;
        const parametrosPeticion = {
            codigo: codigo,
            sistema: sistema,
        }

        // console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('codigo', parametrosPeticion.codigo);
            this.httpHeaders = this.httpHeaders.append('sistema', parametrosPeticion.sistema);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    // console.log('Peticion -> Auth, Iniciar sesión en Dispositivo: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_auth) {
                                if (getData.channel_app[0]?.channel_auth.codigo) {
                                    if (getData.channel_app[0].channel_sistema?.empresa_id) {

                                        resolve(getData);
                                    } else {

                                        resolve(false);
                                        console.log('Seguimiento de errores -> Sistema empresa ID');
                                    }
                                } else {

                                    resolve(false);
                                    console.log('Seguimiento de errores -> Codigo Aquahabiente');
                                }
                            } else {

                                console.log('Seguimiento de errores -> Auth codigo');
                                resolve(false);
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                })
            );

        });
    }

    async dispositivoAuthDocumento(modulo: any, codigo: any, sistema: any) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando sistema ...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater/login_documento' + this.peticionDatosAPI;
        const parametrosPeticion = {
            modulo: modulo,
            codigo: codigo,
            sistema: sistema,
        }

        // console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('modulo', parametrosPeticion.modulo);
            this.httpHeaders = this.httpHeaders.append('codigo', parametrosPeticion.codigo);
            this.httpHeaders = this.httpHeaders.append('sistema', parametrosPeticion.sistema);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    // console.log('Peticion -> Auth,Iniciar sesión en Dispositivo: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_auth) {
                                if (getData.channel_app[0]?.channel_auth.codigo) {
                                    if (getData.channel_app[0].channel_sistema?.empresa_id) {

                                        resolve(getData);
                                    } else {

                                        resolve(false);
                                        console.log('Seguimiento de errores -> Sistema empresa ID');
                                    }
                                } else {

                                    resolve(false);
                                    console.log('Seguimiento de errores -> Codigo Aquahabiente');
                                }
                            } else {

                                console.log('Seguimiento de errores -> Auth codigo');
                                resolve(false);
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                })
            );

        });
    }

    setPaisSeleccionado(pais: any) {
        // console.log('Seguimiento -> Establecer pais. ', pais);
        if (pais.id >= 1) {
            this.paisSeleccionado = pais;
            this.divisas.initDivisas(pais);
            this.auth.appConfig(pais);
        }
    }

    getPaisSeleccionado() {
        return this.paisSeleccionado;
    }

    getIdRoot() {
        return this.idRoot;
    }

    // Verificar Token App
    async checkTokenApp(auth: IAuth): Promise<any> {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando Token de seguridad...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        return new Promise((resolve, reject) => {
            const apiPath = this.apiUrl + '/bancodelagua/getCheckToken' + this.peticionDatosAPI + '&to=' + auth.app_token + '&us=' + auth.usuario + '&ui=' + auth.usuario_id;
            const checkTokenApp = this.subscriptionHttpCheckTokenApp.add(
                this.http.get(apiPath).subscribe((getData: any) => {
                    //console.log('Peticion -> Check Token App: ', data);

                    if (getData?.respuesta) {
                        if (getData.respuesta?.data.auth) {
                            const messages = getData.respuesta.data.msg;
                            //this.toast.msgAppMultiple(messages, 'bottom');
                            resolve(getData.respuesta.data.auth);
                        } else {
                            resolve(false);
                        }
                    } else {
                        resolve(false);
                    }
                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                })
            );

        });

    }


    // PubliAqua Full Anuncios
    //https://api.bancodelagua.com/channel/redatwater/getPubliaquaFullPublicaciones?pass=&empresa=&pais=
    async consultarAnunciosFull(): Promise<any> {
        const loading = await this.loadingCtrl.create({
            message: 'Cargando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        return new Promise((resolve, reject) => {

            const apiPath = this.apiUrl + '/redatwater/listPubliaqua' + this.peticionDatosAPI;
            const listaAnuncios = this.subscriptionHttpCheckTokenApp.add(
                this.http.get(apiPath).subscribe((getData: any) => {
                    //console.log('Peticion -> Full Anuncios PubliAqua: ', getData);
                    if (getData?.respuesta) {

                        const messages = getData.respuesta.data.msg;

                        if (getData.respuesta?.data.publiaqua) {

                            if (getData.respuesta?.data.publiaqua.lista_general) {
                                //this.toast.msgAppMultiple(messages, 'bottom');
                                resolve(getData.respuesta.data.publiaqua);
                            } else {
                                resolve(false);
                            }

                        } else {
                            resolve(false);
                        }
                    } else {
                        resolve(false);
                    }
                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                })
            );

        });
    }

    async aquabotAsistente(tipo: string, message: string) {
        const loading = await this.loadingCtrl.create({
            message: 'Aquabot...',
            spinner: 'crescent',
            showBackdrop: true
        });
        //loading.present();

        return new Promise((resolve, reject) => {

            const apiPath = this.apiUrl + '/aquabot/asistenteAquabot' + this.peticionDatosAPI + '&onAquabot=2&aquabot_tipo=' + tipo + '&aquabot_message=' + message;
            let peticionChannel = this.subscriptionHttp.add(
                this.http.get(apiPath).subscribe((data: any) => {
                    if (data) {
                        /*
                                                if (data.respuesta.data.msg) {
                                                    const messages = data.respuesta.data.msg;
                                                    this.setChannelMessages(messages);
                                                    this.toast.msgAppMultiple(messages, 'bottom');
                                                }
                        */
                        //console.log('Peticion -> AQUABOT: ', data);
                        if (data?.aquabot) {
                            if (data.aquabot) {
                                resolve(data);
                            } else {
                                resolve(false);
                            }
                        } else {
                            resolve(false);
                        }

                    }
                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                })
            );


        });
    }

    // Registro de dispositivo
    async getRegistroDispositivo(contacto: any, servicios: any, dispositivo: any): Promise<any> {
        const loading = await this.loadingCtrl.create({
            message: 'Procesando registro...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater/dispositivoReg' + this.peticionDatosAPI;

        const parametrosPeticion = {
            contacto: contacto,
            servicios: servicios,
            dispositivo: dispositivo
        }

        // console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();

            this.httpHeaders = this.httpHeaders.append('dispositivo_uid', parametrosPeticion.dispositivo.uid);
            this.httpHeaders = this.httpHeaders.append('dispositivo_tipo', parametrosPeticion.dispositivo.tipo);
            this.httpHeaders = this.httpHeaders.append('dispositivo_sistema', parametrosPeticion.dispositivo.sistema);

            // CONTACTO
            this.httpHeaders = this.httpHeaders.append('contacto_celular', parametrosPeticion.contacto.contacto_celular);
            this.httpHeaders = this.httpHeaders.append('contacto_email', parametrosPeticion.contacto.contacto_email);
            this.httpHeaders = this.httpHeaders.append('contacto_ubicacion_direccion', parametrosPeticion.contacto.contacto_ubicacion_direccion);
            this.httpHeaders = this.httpHeaders.append('contacto_ubicacion_lat', parametrosPeticion.contacto.contacto_ubicacion_lat);
            this.httpHeaders = this.httpHeaders.append('contacto_ubicacion_lng', parametrosPeticion.contacto.contacto_ubicacion_lng);
            // SERVICIOS
            if (parametrosPeticion.servicios.length > 0) {
                for (let i = 0; i < parametrosPeticion.servicios.length; i++) {
                    //console.log('Seguimiento -> Servicio: ', parametrosPeticion.servicios[i]);
                    this.httpHeaders = this.httpHeaders.append('servicio_id_' + [i], (parametrosPeticion.servicios[i].servicio_id));
                    this.httpHeaders = this.httpHeaders.append('servicio_nombre_' + [i], (parametrosPeticion.servicios[i].servicio_nombre));
                    if (parametrosPeticion.servicios[i].servicio_precio_maximo_efectivo) {
                        this.httpHeaders = this.httpHeaders.append('servicio_precio_maximo_efectivo_' + [i], (parametrosPeticion.servicios[i].servicio_precio_maximo_efectivo));
                    }
                    this.httpHeaders = this.httpHeaders.append('servicio_precio_maximo_tarjeta_' + [i], (parametrosPeticion.servicios[i].servicio_precio_maximo_tarjeta));
                    if (parametrosPeticion.servicios[i].servicio_precio_efectivo) {
                        this.httpHeaders = this.httpHeaders.append('servicio_precio_efectivo_' + [i], (parametrosPeticion.servicios[i].servicio_precio_efectivo));
                    }
                    this.httpHeaders = this.httpHeaders.append('servicio_precio_tarjeta_' + [i], (parametrosPeticion.servicios[i].servicio_precio_tarjeta));
                    if (parametrosPeticion.servicios[i].servicio_tiempo_efectivo_1litro) {
                        this.httpHeaders = this.httpHeaders.append('servicio_tiempo_efectivo_1litro_' + [i], (parametrosPeticion.servicios[i].servicio_tiempo_efectivo_1litro));
                    }
                    this.httpHeaders = this.httpHeaders.append('servicio_tiempo_tarjeta_1litro_' + [i], (parametrosPeticion.servicios[i].servicio_tiempo_tarjeta_1litro));
                    if (parametrosPeticion?.servicios[i].servicio_tiempo_efectivo_10litros) {
                        this.httpHeaders = this.httpHeaders.append('servicio_tiempo_efectivo_10litros_' + [i], (parametrosPeticion.servicios[i].servicio_tiempo_efectivo_10litros));
                    }
                    if (parametrosPeticion?.servicios[i].servicio_tiempo_tarjeta_10litros) {
                        this.httpHeaders = this.httpHeaders.append('servicio_tiempo_tarjeta_10litros_' + [i], (parametrosPeticion.servicios[i].servicio_tiempo_tarjeta_10litros));
                    }
                    if (parametrosPeticion?.servicios[i].servicio_tiempo_efectivo_20litros) {
                        this.httpHeaders = this.httpHeaders.append('servicio_tiempo_efectivo_20litros_' + [i], (parametrosPeticion.servicios[i].servicio_tiempo_efectivo_20litros));
                    }
                    if (parametrosPeticion?.servicios[i].servicio_tiempo_tarjeta_20litro) {
                        this.httpHeaders = this.httpHeaders.append('servicio_tiempo_tarjeta_20litros_' + [i], (parametrosPeticion.servicios[i].servicio_tiempo_tarjeta_20litros));
                    }
                }
            }

            const addPanel = this.subscriptionHttpAgregarPanel.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Seguimiento de Peticion -> Registrar panel: ', getData);
                    if (getData?.channel.conexion_fecha) {
                        if (getData?.auth_dispositivo) {
                            resolve(getData);
                            loading.dismiss();
                        } else {
                            console.log('Seguimiento de errores -> Parametros de dispositivo auth. ', getData);
                            loading.dismiss();
                            resolve(false);
                        }
                    } else {
                        console.log('Seguimiento de errores -> Parametros de peticion. ', getData);
                        loading.dismiss();
                        resolve(false);
                    }

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                })
            );

        });

    }

    // INFORMACION DE SISTEMA
    async getDataSistema(sistema_id: any) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando sistema ...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater/getDataSistema' + this.peticionDatosAPI;
        const parametrosPeticion = {
            sistema: sistema_id,
        }

        //console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('sistema', parametrosPeticion.sistema);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    //console.log('Peticion -> Sistemas, Datos de sistema: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema) {

                                if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                    resolve(getData);
                                } else {

                                    resolve(false);
                                    console.log('Seguimiento de errores -> Sistema empresa ID');
                                }

                            } else {
                                console.log('Seguimiento -> ', getData.messages);
                            }
                        } else {
                            resolve(false);
                        }
                        //console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }

    // CONSULTAR CUENTA AQUAHABIENTE ADMIN POR CODIGO Y CLAVE
    async getCuentaAdminAquahabiente(dispositivo_id: string, aquahabiente: any) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando cuenta ...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();
        const apiPath = this.apiUrl + '/redatwater/getCuentaAdminAquahabiente' + this.peticionDatosAPI;

        const parametrosPeticion = {
            dispositivo_id: dispositivo_id,
            encriptado: aquahabiente.encriptado,
            cuenta: aquahabiente.codigo,
            clave: aquahabiente.clave
        }

        // console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('encriptado', parametrosPeticion.encriptado);
            this.httpHeaders = this.httpHeaders.append('cuenta', parametrosPeticion.cuenta);
            this.httpHeaders = this.httpHeaders.append('clave', parametrosPeticion.clave);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    // console.log('Peticion -> Aquahabiente ADMIN, Datos de cuenta: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData?.channel_app[0]) {
                                resolve(getData);
                            } else {
                                resolve(false);
                                console.log('Seguimiento de errores -> ');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }


    // CONSULTAR CUENTA AQUAHABIENTE POR CUENTA Y CLAVE
    async getCuentaAquahabiente(cuenta: string, clave: string, encriptado: number) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando cuenta ...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();
        const apiPath = this.apiUrl + '/redatwater/getCuentaAquahabiente' + this.peticionDatosAPI;

        const parametrosPeticion = {
            encriptado: encriptado,
            cuenta: cuenta,
            clave: clave
        }

        // console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('encriptado', parametrosPeticion.encriptado);
            this.httpHeaders = this.httpHeaders.append('cuenta', parametrosPeticion.cuenta);
            this.httpHeaders = this.httpHeaders.append('clave', parametrosPeticion.clave);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    //  console.log('Peticion -> Aquahabiente, Datos de cuenta: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData?.channel_app[0]) {
                                resolve(getData);
                            } else {
                                resolve(false);
                                console.log('Seguimiento de errores -> ');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }

    // CONSULTAR CUENTA AQUAHABIENTE POR CUENTA
    async getCuentaAquahabienteCodigo(cuenta: string) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando cuenta ...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();
        const apiPath = this.apiUrl + '/redatwater/getCuentaAquahabienteCodigo' + this.peticionDatosAPI;

        const parametrosPeticion = {
            cuenta: cuenta
        }

        // console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('cuenta', parametrosPeticion.cuenta);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    // console.log('Peticion -> Aquahabiente, Datos de cuenta: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData?.channel_app) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> ');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }

    // CONSULTAR TICKET POR CODIGO Y CLAVE
    async getTicketAgua(codigo: string, clave: string, encriptado: number) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando ticket ...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater/getTicketAgua' + this.peticionDatosAPI;
        const parametrosPeticion = {
            encriptado: encriptado,
            codigo: codigo,
            clave: clave
        }

        // console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('encriptado', parametrosPeticion.encriptado);
            this.httpHeaders = this.httpHeaders.append('codigo', parametrosPeticion.codigo);
            this.httpHeaders = this.httpHeaders.append('clave', parametrosPeticion.clave);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    // console.log('Peticion -> Ticket de agua, Datos de ticket: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData?.channel_app[0]) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> ');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }

    // CONSULTAR TICKET POR CODIGO 
    async getTicketAguaCodigo(codigo: string) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando ticket ...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater/getTicketAguaCodigo' + this.peticionDatosAPI;
        const parametrosPeticion = {
            codigo: codigo
        }

        //  console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('codigo', parametrosPeticion.codigo);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    // console.log('Peticion -> Ticket de agua, Datos de ticket: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData?.channel_app[0]) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> ');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }


    /*********************   /
        PROCESOS EN 2DO PLANO
    ******************************************/

    // RELE DE MEDIO DE PAGO EN EFECTIVO
    /*
        CONTEO DE EFECTIVO
        ENCENDER Y APAGAR COMPONENTE
    */
    async getReleEfectivo(dispositivo_id: string, estado_rele: string, total_pago: number) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando efectivo ...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater/getReleEfectivo' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id,
            estado_rele: estado_rele,
            total_pago: total_pago
        }

        // console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('estado_rele', parametrosPeticion.estado_rele);
            this.httpHeaders = this.httpHeaders.append('total_pago', parametrosPeticion.total_pago);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    //   console.log('Peticion -> Rele de Efectivo, Datos de control: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData?.channel_app[0]) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> ');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }

    // ESTADO DE CONEXION DE SISTEMA
    /*
        TELEMETRIA,
        DISPONIBILIDAD
    */
    async getConexionSistema(dispositivo_id: string) {
        const loading = await this.loadingCtrl.create({
            message: 'RED AT-WATER ...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater/getConexionSistema' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id,
        }

        //  console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    //  console.log('Peticion -> Conexion de Sistema, Estado de conexión: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData?.channel_app[0]) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> ');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }


    // PROCESOS DE DISPOSITIVO
    /*
        LISTADO DE PROCESOS DE DISPOSITIVO ASOCIADO
    */
    async getProcesosDispositivo(dispositivo_id: string, estado_rele: string) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando procesos ...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater/getProcesosDispositivo' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id
        }

        // console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    // console.log('Peticion -> Procesos de dispositivo, Lista de procesos: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData?.channel_app[0]) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> ');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }


    async getProcesos(dispositivo_id: string) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando procesos ...',
            spinner: 'crescent',
            showBackdrop: true
        });
        //loading.present();

        const apiPath = this.apiUrl + '/redatwater/getProcesos' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id
        }

        // console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    //  console.log('Peticion -> Procesos, Datos de control: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData?.channel_app[0]) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> ');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }


    /*
    ************** CAJEROS DE AGUA ************
        COMPRA CAJERO EFECTIVO
    */
    async getCajeroCompra(dispositivo_id: String, metodo_pay: String, dataCompra: any) {
        const loading = await this.loadingCtrl.create({
            message: 'RED AT-WATER ...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        if (metodo_pay === 'efectivo') {

            const apiPath = this.apiUrl + '/redatwater_atwater/getCajeroCompra' + this.peticionDatosAPI;
            const parametrosPeticion = {
                dispositivo_id: dispositivo_id,
                metodo_pay: metodo_pay,
                enjuague: dataCompra.enjuague,
                valor_compra: dataCompra.valor_compra,
                total_litros: dataCompra.compra_litros,
                servicio_id: dataCompra.servicio
            }

            //console.log('Data -> ' + parametrosPeticion);

            return new Promise((resolve, reject) => {

                this.httpHeaders = new HttpParams();
                this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
                this.httpHeaders = this.httpHeaders.append('metodo_pay', parametrosPeticion.metodo_pay);

                // ADICIONAL
                this.httpHeaders = this.httpHeaders.append('enjuague', parametrosPeticion.enjuague);
                this.httpHeaders = this.httpHeaders.append('valor_compra', parametrosPeticion.valor_compra);
                this.httpHeaders = this.httpHeaders.append('total_litros', parametrosPeticion.total_litros);
                this.httpHeaders = this.httpHeaders.append('servicio_id', parametrosPeticion.servicio_id);

                const peticionAuth = this.subscriptionHttp.add(
                    this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                        // console.log('Peticion -> Conexion de Sistema, Compra en Cajero: ', getData);

                        if (getData) {
                            if (getData?.messages) {
                                this.setChannelMessages(getData?.messages);
                            }
                            if (getData?.channel.conexion_token) {
                                if (getData?.channel_app[0]) {

                                    resolve(getData);
                                } else {

                                    resolve(false);
                                    console.log('Seguimiento de errores -> ');
                                }
                            } else {
                                resolve(false);
                            }
                            console.log('Seguimiento -> ', getData.messages);
                        } else {
                            resolve(false);
                        }

                        loading.dismiss();

                    }, (err: any) => {
                        console.log('Seguimiento de errores -> HTTP: ', err);
                        loading.dismiss();
                        resolve(false);
                    })
                );

            });

        } else if (metodo_pay === 'aquahabiente') {

            const apiPath = this.apiUrl + '/redatwater_atwater/getCajeroCompra' + this.peticionDatosAPI;
            const parametrosPeticion = {
                dispositivo_id: dispositivo_id,
                metodo_pay: metodo_pay,
                encriptado: dataCompra.encriptado,
                enjuague: dataCompra.enjuague,
                total_litros: dataCompra.compra_litros,
                servicio_id: dataCompra.servicio,
                cuenta: dataCompra.cuenta,
                clave: dataCompra.clave
            }
            // console.log('Data -> ' + parametrosPeticion);

            return new Promise((resolve, reject) => {

                this.httpHeaders = new HttpParams();
                this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
                this.httpHeaders = this.httpHeaders.append('metodo_pay', parametrosPeticion.metodo_pay);

                // ADICIONAL
                this.httpHeaders = this.httpHeaders.append('encriptado', parametrosPeticion.encriptado);
                this.httpHeaders = this.httpHeaders.append('enjuague', parametrosPeticion.enjuague);
                this.httpHeaders = this.httpHeaders.append('total_litros', parametrosPeticion.total_litros);
                this.httpHeaders = this.httpHeaders.append('servicio_id', parametrosPeticion.servicio_id);
                this.httpHeaders = this.httpHeaders.append('cuenta', parametrosPeticion.cuenta);
                this.httpHeaders = this.httpHeaders.append('clave', parametrosPeticion.clave);

                const peticionAuth = this.subscriptionHttp.add(
                    this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                        // console.log('Peticion -> Conexion de Sistema, Compra en Cajero: ', getData);

                        if (getData) {
                            if (getData?.messages) {
                                this.setChannelMessages(getData?.messages);
                            }
                            if (getData?.channel.conexion_token) {
                                if (getData?.channel_app[0]) {

                                    resolve(getData);
                                } else {

                                    resolve(false);
                                    console.log('Seguimiento de errores -> ');
                                }
                            } else {
                                resolve(false);
                            }
                            console.log('Seguimiento -> ', getData.messages);
                        } else {
                            resolve(false);
                        }

                        loading.dismiss();

                    }, (err: any) => {
                        console.log('Seguimiento de errores -> HTTP: ', err);
                        loading.dismiss();
                        resolve(false);
                    })
                );

            });

        } else if (metodo_pay === 'ticket') {

            const apiPath = this.apiUrl + '/redatwater_atwater/getCajeroCompra' + this.peticionDatosAPI;
            const parametrosPeticion = {
                dispositivo_id: dispositivo_id,
                metodo_pay: metodo_pay,
                encriptado: dataCompra.encriptado,
                enjuague: dataCompra.enjuague,
                total_litros: dataCompra.compra_litros,
                servicio_id: dataCompra.servicio,
                codigo: dataCompra.codigo,
                clave: dataCompra.clave
            }
            // console.log('Data -> ' + parametrosPeticion);

            return new Promise((resolve, reject) => {

                this.httpHeaders = new HttpParams();
                this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
                this.httpHeaders = this.httpHeaders.append('metodo_pay', parametrosPeticion.metodo_pay);

                // ADICIONAL
                this.httpHeaders = this.httpHeaders.append('encriptado', parametrosPeticion.encriptado);
                this.httpHeaders = this.httpHeaders.append('enjuague', parametrosPeticion.enjuague);
                this.httpHeaders = this.httpHeaders.append('total_litros', parametrosPeticion.total_litros);
                this.httpHeaders = this.httpHeaders.append('servicio_id', parametrosPeticion.servicio_id);
                this.httpHeaders = this.httpHeaders.append('codigo', parametrosPeticion.codigo);
                this.httpHeaders = this.httpHeaders.append('clave', parametrosPeticion.clave);

                const peticionAuth = this.subscriptionHttp.add(
                    this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                        // console.log('Peticion -> Conexion de Sistema, Compra en Cajero: ', getData);

                        if (getData) {
                            if (getData?.messages) {
                                this.setChannelMessages(getData?.messages);
                            }
                            if (getData?.channel.conexion_token) {
                                if (getData?.channel_app[0]) {

                                    resolve(getData);
                                } else {

                                    resolve(false);
                                    console.log('Seguimiento de errores -> ');
                                }
                            } else {
                                resolve(false);
                            }
                            console.log('Seguimiento -> ', getData.messages);
                        } else {
                            resolve(false);
                        }

                        loading.dismiss();

                    }, (err: any) => {
                        console.log('Seguimiento de errores -> HTTP: ', err);
                        loading.dismiss();
                        resolve(false);
                    })
                );

            });

        } else if (metodo_pay === 'nequi') {

            const apiPath = this.apiUrl + '/redatwater_atwater/getCajeroCompra' + this.peticionDatosAPI;
            const parametrosPeticion = {
                dispositivo_id: dispositivo_id,
                metodo_pay: metodo_pay,
                enjuague: dataCompra.enjuague,
                valor_compra: dataCompra.valor_compra,
                total_litros: dataCompra.compra_litros,
                celular: dataCompra.celular,
                servicio_id: dataCompra.servicio
            }
            // console.log('Data -> ' + parametrosPeticion);

            return new Promise((resolve, reject) => {

                this.httpHeaders = new HttpParams();
                this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
                this.httpHeaders = this.httpHeaders.append('metodo_pay', parametrosPeticion.metodo_pay);

                // ADICIONAL
                this.httpHeaders = this.httpHeaders.append('enjuague', parametrosPeticion.enjuague);
                this.httpHeaders = this.httpHeaders.append('valor_compra', parametrosPeticion.valor_compra);
                this.httpHeaders = this.httpHeaders.append('celular', parametrosPeticion.celular);
                this.httpHeaders = this.httpHeaders.append('total_litros', parametrosPeticion.total_litros);
                this.httpHeaders = this.httpHeaders.append('servicio_id', parametrosPeticion.servicio_id);

                const peticionAuth = this.subscriptionHttp.add(
                    this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                        // console.log('Peticion -> Conexion de Sistema, Compra en Cajero: ', getData);

                        if (getData) {
                            if (getData?.messages) {
                                this.setChannelMessages(getData?.messages);
                            }
                            if (getData?.channel.conexion_token) {
                                if (getData?.channel_app[0]) {

                                    resolve(getData);
                                } else {

                                    resolve(false);
                                    console.log('Seguimiento de errores -> ');
                                }
                            } else {
                                resolve(false);
                            }
                            console.log('Seguimiento -> ', getData.messages);
                        } else {
                            resolve(false);
                        }

                        loading.dismiss();

                    }, (err: any) => {
                        console.log('Seguimiento de errores -> HTTP: ', err);
                        loading.dismiss();
                        resolve(false);
                    })
                );

            });

        } else {

        }
    }


    async getCajeroPedidosCola(dispositivo_id: string) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando Pedidos...',
            spinner: 'crescent',
            showBackdrop: true
        });
        //loading.present();

        const apiPath = this.apiUrl + '/redatwater_atwater/getCajeroPedidosCola' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id
        }

        // console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    // console.log('Peticion -> Pedidos en cola: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData?.channel_app[0]) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> ');
                            }
                        } else {
                            resolve(false);
                        }
                        // console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    // loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }


    async confirmarPedidoDomiciliario(pedido: any) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando ...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_atwater/confirmarPedidoDomiciliario' + this.peticionDatosAPI;
        const parametrosPeticion = {
            pedido: pedido.pedido_id,
            sistema: pedido.sistema_key,
        }

        //console.log('Data -> ' + JSON.stringify(parametrosPeticion));

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('pedido', parametrosPeticion.pedido);
            this.httpHeaders = this.httpHeaders.append('sistema', parametrosPeticion.sistema);

            const peticionPedido = this.subscriptionHttp.add(

                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Cajero AT-WATER, Confirmar pedido AT-WATER: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_sistema) {
                                if (getData.channel_sistema?.pedido_id) {
                                    if (getData.channel_sistema?.sistema_id) {

                                        resolve(getData);

                                    } else {

                                        resolve(false);
                                        console.log('Seguimiento de errores -> Sistema ID');
                                    }
                                } else {

                                    resolve(false);
                                    console.log('Seguimiento de errores -> Pedido ID');
                                }
                            } else {

                                console.log('Seguimiento de errores -> Parametros pedido');
                                resolve(false);
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', JSON.stringify(err));
                    loading.dismiss();
                })
            );

        });
    }

    /***************************** 
    RECYCLA
    */
    async getRecyclaPedidosCola(dispositivo_id: string) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando Pedidos...',
            spinner: 'crescent',
            showBackdrop: true
        });
        //loading.present();

        const apiPath = this.apiUrl + '/redatwater_recycla/getRecyclaPedidosCola' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id
        }

        //console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Pedidos en cola: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData?.channel_app[0]) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> ');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    // loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    //loading.dismiss();
                    resolve(false);
                })
            );

        });
    }

    async recyclaAuth(codigo: any, sistema: any, contenedor1?: number, contenedor2?: number, contenedor3?: number, contenedor4?: number, contenedor5?: number, contenedor6?: number) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_recycla/recyclaAuth' + this.peticionDatosAPI;
        const parametrosPeticion = {
            codigo: codigo,
            sistema: sistema,
            s_contenedor1: contenedor1,
            s_contenedor2: contenedor2,
            s_contenedor3: contenedor3,
            s_contenedor4: contenedor4,
            s_contenedor5: contenedor5,
            s_contenedor6: contenedor6
        }

        // console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('codigo', parametrosPeticion.codigo);
            this.httpHeaders = this.httpHeaders.append('sistema', parametrosPeticion.sistema);

            if (parametrosPeticion.s_contenedor1) {
                this.httpHeaders = this.httpHeaders.append('s_contenedor1', parametrosPeticion.s_contenedor1);
            }

            if (parametrosPeticion.s_contenedor2) {
                this.httpHeaders = this.httpHeaders.append('s_contenedor2', parametrosPeticion.s_contenedor2);
            }

            if (parametrosPeticion.s_contenedor3) {
                this.httpHeaders = this.httpHeaders.append('s_contenedor3', parametrosPeticion.s_contenedor3);
            }

            if (parametrosPeticion.s_contenedor4) {
                this.httpHeaders = this.httpHeaders.append('s_contenedor4', parametrosPeticion.s_contenedor4);
            }

            if (parametrosPeticion.s_contenedor5) {
                this.httpHeaders = this.httpHeaders.append('s_contenedor5', parametrosPeticion.s_contenedor5);
            }

            if (parametrosPeticion.s_contenedor6) {
                this.httpHeaders = this.httpHeaders.append('s_contenedor6', parametrosPeticion.s_contenedor6);
            }


            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Auth, Iniciar sesión en Recycla: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_auth) {
                                if (getData.channel_app[0]?.channel_auth.codigo) {
                                    if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                        resolve(getData);
                                    } else {

                                        resolve(false);
                                        console.log('Seguimiento de errores -> Sistema empresa ID');
                                    }
                                } else {

                                    resolve(false);
                                    console.log('Seguimiento de errores -> Codigo Aquahabiente');
                                }
                            } else {

                                console.log('Seguimiento de errores -> Auth codigo');
                                resolve(false);
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }


    async recyclaEditarSubProceso(dispositivo_id: string, proceso: any) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_recycla/getEditarSubProcesoRecycla' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id,
            proceso_id: proceso.id,
            proceso_data: proceso.data,
            proceso_aux_data: proceso.aux_data,
            proceso_estado: proceso.estado,
            proceso_temporal: proceso.temporal,
            proceso_autor_app: proceso.autor_app,
            proceso_autor_sistema: proceso.autor_sistema,
            proceso_json_aux: JSON.stringify(proceso.codigos)
        }

        // console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('proceso_id', parametrosPeticion.proceso_id);
            this.httpHeaders = this.httpHeaders.append('proceso_data', parametrosPeticion.proceso_data);
            this.httpHeaders = this.httpHeaders.append('proceso_aux_data', parametrosPeticion.proceso_aux_data);
            this.httpHeaders = this.httpHeaders.append('proceso_estado', parametrosPeticion.proceso_estado);
            this.httpHeaders = this.httpHeaders.append('proceso_temporal', parametrosPeticion.proceso_temporal);
            this.httpHeaders = this.httpHeaders.append('proceso_autor_app', parametrosPeticion.proceso_autor_app);
            this.httpHeaders = this.httpHeaders.append('proceso_autor_sistema', parametrosPeticion.proceso_autor_sistema);
            this.httpHeaders = this.httpHeaders.append('proceso_json_aux', parametrosPeticion.proceso_json_aux);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Recycla, Editar Sub proceso: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> Sistema empresa ID');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }


    async recyclaFinalizarProceso(dispositivo_id: string, pedido: string, tipo: string) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_recycla/getConfirmarProcesoRecycla' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id,
            pedido_id: pedido,
            tipo: tipo
        }

        // console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('pedido_id', parametrosPeticion.pedido_id);
            this.httpHeaders = this.httpHeaders.append('tipo', parametrosPeticion.tipo);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Recycla, Finalizar de proceso: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> Sistema empresa ID');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }

    /*
    ****************************
    CAJERO AUTOMATICO
    */
    async getAutomaticoConexionSistema(dispositivo_id: string) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando Pedidos...',
            spinner: 'crescent',
            showBackdrop: true
        });
        //loading.present();

        const apiPath = this.apiUrl + '/redatwater_automatico/getAutomaticoConexionSistema' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id
        }

        // console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Conexion de sistema: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData?.channel_app[0]) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> ');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    // loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }

    async getAutomaticoRegistrarClave(dispositivo_id: string, servicio: any, aquahabiente: any) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_automatico/getAutomaticoRegistrarClave' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id,
            servicio_id: servicio.id,
            codigo: aquahabiente.codigo,
            clave: aquahabiente.clave
        }

        // console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('servicio_id', parametrosPeticion.servicio_id);
            this.httpHeaders = this.httpHeaders.append('aquahabiente_codigo', parametrosPeticion.codigo);
            this.httpHeaders = this.httpHeaders.append('aquahabiente_clave', parametrosPeticion.clave);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Cajero automatico, Registrar clave: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> Sistema empresa ID');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }

    async getAutomaticoEditarClave(dispositivo_id: string, servicio: any, aquahabiente: any) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_automatico/getAutomaticoEditarClave' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id,
            servicio_id: servicio.id,
            codigo: aquahabiente.codigo,
            clave: aquahabiente.clave_login,
            encriptado: aquahabiente.encriptado,
            new_clave: aquahabiente.clave
        }

        // console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('servicio_id', parametrosPeticion.servicio_id);
            this.httpHeaders = this.httpHeaders.append('aquahabiente_codigo', parametrosPeticion.codigo);
            this.httpHeaders = this.httpHeaders.append('aquahabiente_clave', parametrosPeticion.clave);
            this.httpHeaders = this.httpHeaders.append('aquahabiente_encriptado', parametrosPeticion.encriptado);
            this.httpHeaders = this.httpHeaders.append('aquahabiente_newclave', parametrosPeticion.new_clave);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Cajero automatico, Editar clave: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> Sistema empresa ID');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }

    async getAutomaticoRecargarTarjeta(dispositivo_id: string, servicio: any, aquahabiente: any, pay: any, totalRecarga: number) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_automatico/getAutomaticoRecargarTarjeta' + this.peticionDatosAPI;
        const parametrosPeticion: any = {
            dispositivo_id: dispositivo_id,
            servicio_id: servicio.id,
            codigo: aquahabiente.codigo,
            clave: aquahabiente.clave_login,
            comprobante_pay: pay.metodo,
            encriptado: aquahabiente.encriptado,
            saldo_recargar: totalRecarga
        }

        if (parametrosPeticion.comprobante_pay === 'aquahabiente') {
            parametrosPeticion.autor_codigo = pay.aquahabiente.cuenta;
            parametrosPeticion.autor_clave = pay.aquahabiente.clave;
        }

        // console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('servicio_id', parametrosPeticion.servicio_id);
            this.httpHeaders = this.httpHeaders.append('pay_comprobante', parametrosPeticion.comprobante_pay);

            this.httpHeaders = this.httpHeaders.append('aquahabiente_codigo', parametrosPeticion.codigo);
            this.httpHeaders = this.httpHeaders.append('aquahabiente_clave', parametrosPeticion.clave);
            this.httpHeaders = this.httpHeaders.append('aquahabiente_encriptado', parametrosPeticion.encriptado);
            this.httpHeaders = this.httpHeaders.append('aquahabiente_saldo_recargar', parametrosPeticion.saldo_recargar);

            if (parametrosPeticion.comprobante_pay === 'aquahabiente') {
                this.httpHeaders = this.httpHeaders.append('autor_codigo', parametrosPeticion.autor_codigo);
                this.httpHeaders = this.httpHeaders.append('autor_clave', parametrosPeticion.autor_clave);
            }

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Cajero automatico, Recargar tarjeta: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> Sistema empresa ID');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }



    async getAutomaticoTransferencia(dispositivo_id: string, servicio: any, aquahabiente: any, pay: any, totalTransferencia: number) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_automatico/getAutomaticoTransferencia' + this.peticionDatosAPI;
        const parametrosPeticion: any = {
            dispositivo_id: dispositivo_id,
            servicio_id: servicio.id,
            codigo: aquahabiente.codigo,
            comprobante_pay: pay.metodo,
            encriptado: aquahabiente.encriptado,
            saldo_transferir: totalTransferencia
        }

        if (parametrosPeticion.comprobante_pay === 'aquahabiente') {
            parametrosPeticion.autor_codigo = pay.aquahabiente.cuenta;
            parametrosPeticion.autor_clave = pay.aquahabiente.clave;
        }

        // console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('servicio_id', parametrosPeticion.servicio_id);
            this.httpHeaders = this.httpHeaders.append('pay_comprobante', parametrosPeticion.comprobante_pay);

            this.httpHeaders = this.httpHeaders.append('aquahabiente_codigo', parametrosPeticion.codigo);
            this.httpHeaders = this.httpHeaders.append('aquahabiente_encriptado', parametrosPeticion.encriptado);
            this.httpHeaders = this.httpHeaders.append('aquahabiente_saldo_transferir', parametrosPeticion.saldo_transferir);

            if (parametrosPeticion.comprobante_pay === 'aquahabiente') {
                this.httpHeaders = this.httpHeaders.append('autor_codigo', parametrosPeticion.autor_codigo);
                this.httpHeaders = this.httpHeaders.append('autor_clave', parametrosPeticion.autor_clave);
            }

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Cajero automatico, Transferencia: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> Sistema empresa ID');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }


    async getAutomaticoTicketsAguaDisponibles(dispositivo_id: string) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_automatico/getAutomaticoTicketsAguaDisponibles' + this.peticionDatosAPI;
        const parametrosPeticion: any = {
            dispositivo_id: dispositivo_id,
        }

        // console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Consultando lotes de tickets de agua: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> Sistema empresa ID');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }

    async getAutomaticoTicketComprar(dispositivo_id: string, servicio: any, propiedad: any, pay: any, lote_ticket: any) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_automatico/getAutomaticoTicketComprar' + this.peticionDatosAPI;
        const parametrosPeticion: any = {
            dispositivo_id: dispositivo_id,
            comprobante_pay: pay.metodo,
            lote_ticket_id: lote_ticket.id,
            servicio_id: servicio.id,
            encriptado: propiedad.encriptado,
            tipo_compra: propiedad.tipo_compra
        }

        if (propiedad.tipo_compra === 'comprar') {
            parametrosPeticion.propiedad_nombre = propiedad.nombre;
            parametrosPeticion.propiedad_cel = propiedad.cel;
            parametrosPeticion.propiedad_email = propiedad.email;
        }

        if (propiedad.tipo_compra === 'asociar') {
            parametrosPeticion.propiedad_codigo = propiedad.codigo;
        }

        if (parametrosPeticion.comprobante_pay === 'aquahabiente') {
            parametrosPeticion.autor_codigo = pay.aquahabiente.cuenta;
            parametrosPeticion.autor_clave = pay.aquahabiente.clave;
        }


        // console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('pay_comprobante', parametrosPeticion.comprobante_pay);
            this.httpHeaders = this.httpHeaders.append('lote_ticket_id', parametrosPeticion.lote_ticket_id);
            this.httpHeaders = this.httpHeaders.append('servicio_id', parametrosPeticion.servicio_id);
            this.httpHeaders = this.httpHeaders.append('propiedad_encriptado', parametrosPeticion.encriptado);
            this.httpHeaders = this.httpHeaders.append('tipo_compra', parametrosPeticion.tipo_compra);

            if (parametrosPeticion.comprobante_pay === 'aquahabiente') {
                this.httpHeaders = this.httpHeaders.append('autor_codigo', parametrosPeticion.autor_codigo);
                this.httpHeaders = this.httpHeaders.append('autor_clave', parametrosPeticion.autor_clave);
            }

            if (propiedad.tipo_compra === 'comprar') {
                this.httpHeaders = this.httpHeaders.append('propiedad_nombre', parametrosPeticion.propiedad_nombre);
                this.httpHeaders = this.httpHeaders.append('propiedad_cel', parametrosPeticion.propiedad_cel);
                this.httpHeaders = this.httpHeaders.append('propiedad_email', parametrosPeticion.propiedad_email);

            }

            if (propiedad.tipo_compra === 'asociar') {
                this.httpHeaders = this.httpHeaders.append('propiedad_codigo', parametrosPeticion.propiedad_codigo);
            }

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Cajero automatico, Comprar ticket de agua: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> Sistema empresa ID');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }


    async getAutomaticoComprarTicketPin(dispositivo_id: string, servicio: any, aquahabiente: any, pay: any, precio_pin: number) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_automatico/getAutomaticoComprarTicketPin' + this.peticionDatosAPI;
        const parametrosPeticion: any = {
            dispositivo_id: dispositivo_id,
            comprobante_pay: pay.metodo,
            servicio_id: servicio.id,
            encriptado: aquahabiente.encriptado,
            pin_email: aquahabiente.email,
            pin_cc: aquahabiente.cel,
            pin_nombre: aquahabiente.nombre,
            pin_precio: precio_pin
        }

        if (parametrosPeticion.comprobante_pay === 'aquahabiente') {
            parametrosPeticion.autor_codigo = pay.aquahabiente.cuenta;
            parametrosPeticion.autor_clave = pay.aquahabiente.clave;
        }

        // console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('pay_comprobante', parametrosPeticion.comprobante_pay);
            this.httpHeaders = this.httpHeaders.append('servicio_id', parametrosPeticion.servicio_id);
            this.httpHeaders = this.httpHeaders.append('aquahabiente_encriptado', parametrosPeticion.encriptado);

            this.httpHeaders = this.httpHeaders.append('pin_email', parametrosPeticion.pin_email);
            this.httpHeaders = this.httpHeaders.append('pin_cc', parametrosPeticion.pin_cc);
            this.httpHeaders = this.httpHeaders.append('pin_nombre', parametrosPeticion.pin_nombre);
            this.httpHeaders = this.httpHeaders.append('pin_precio', parametrosPeticion.pin_precio);

            if (parametrosPeticion.comprobante_pay === 'aquahabiente') {
                this.httpHeaders = this.httpHeaders.append('autor_codigo', parametrosPeticion.autor_codigo);
                this.httpHeaders = this.httpHeaders.append('autor_clave', parametrosPeticion.autor_clave);
            }


            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Cajero automatico, Comprar PIN unico: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> Sistema empresa ID');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }


    async getAutomaticoTicketRecargar(dispositivo_id: string, servicio: any, ticket: any, pay: any, total_litros: number) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_automatico/getAutomaticoTicketRecargar' + this.peticionDatosAPI;
        const parametrosPeticion: any = {
            dispositivo_id: dispositivo_id,
            comprobante_pay: pay.metodo,
            servicio_id: servicio.id,
            encriptado: ticket.encriptado,
            ticket_codigo: ticket.codigo,
            ticket_clave: ticket.clave,
            ticket_litros: total_litros
        }

        if (parametrosPeticion.comprobante_pay === 'aquahabiente') {
            parametrosPeticion.autor_codigo = pay.aquahabiente.cuenta;
            parametrosPeticion.autor_clave = pay.aquahabiente.clave;
        }

        console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('servicio_id', parametrosPeticion.servicio_id);
            this.httpHeaders = this.httpHeaders.append('pay_comprobante', parametrosPeticion.comprobante_pay);
            this.httpHeaders = this.httpHeaders.append('ticket_encriptado', parametrosPeticion.encriptado);
            this.httpHeaders = this.httpHeaders.append('ticket_codigo', parametrosPeticion.ticket_codigo);
            this.httpHeaders = this.httpHeaders.append('ticket_clave', parametrosPeticion.ticket_clave);
            this.httpHeaders = this.httpHeaders.append('ticket_litros', parametrosPeticion.ticket_litros);

            if (parametrosPeticion.comprobante_pay === 'aquahabiente') {
                this.httpHeaders = this.httpHeaders.append('autor_codigo', parametrosPeticion.autor_codigo);
                this.httpHeaders = this.httpHeaders.append('autor_clave', parametrosPeticion.autor_clave);
            }

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Cajero automatico, Recargar ticket de agua: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> Sistema empresa ID');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }

    async getAutomaticoTicketVerificar(dispositivo_id: string, tickets: any) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_automatico/getAutomaticoTicketVerificar' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id,
            comprobante_pay: tickets.pay_comprobante,
            ticket_codigo: tickets.codigo,
            ticket_clave: tickets.clave
        }

        console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('ticket_codigo', parametrosPeticion.ticket_codigo);
            this.httpHeaders = this.httpHeaders.append('ticket_clave', parametrosPeticion.ticket_clave);
            this.httpHeaders = this.httpHeaders.append('ticket_pay_comprobante', parametrosPeticion.comprobante_pay);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Cajero automatico, Verificar ticket de agua: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> Sistema empresa ID');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }


    /*
    ***********************
    REFILL VENDING 
    **********************
    */

    async getRefillPedidosCola(dispositivo_id: string) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando Pedidos...',
            spinner: 'crescent',
            showBackdrop: true
        });
        //loading.present();

        const apiPath = this.apiUrl + '/redatwater_refill/getRefillPedidosCola' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id
        }

        console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Pedidos en cola: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData?.channel_app[0]) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> ');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    // loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    //loading.dismiss();
                    resolve(false);
                })
            );

        });
    }

    async getAddPedidoRefill(dispositivo_id: any, pay: any, contenedor1?: any, contenedor2?: any, contenedor3?: any, contenedor4?: any, contenedor5?: any, contenedor6?: any) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_refill/getAddPedidoRefill' + this.peticionDatosAPI;
        const parametrosPeticion: any = {
            dispositivo_id: dispositivo_id,
            comprobante_pay: pay.metodo,
            encriptado: pay.encriptado,
            s_contenedor1: contenedor1.id,
            s_contenedor1_cantidad: contenedor1.cantidad,
            s_contenedor2: contenedor2.id,
            s_contenedor2_cantidad: contenedor2.cantidad,
            s_contenedor3: contenedor3.id,
            s_contenedor3_cantidad: contenedor3.cantidad,
            s_contenedor4: contenedor4.id,
            s_contenedor4_cantidad: contenedor4.cantidad,
            s_contenedor5: contenedor5.id,
            s_contenedor5_cantidad: contenedor5.cantidad,
            s_contenedor6: contenedor6.id,
            s_contenedor6_cantidad: contenedor6.cantidad
        }

        if (parametrosPeticion.comprobante_pay === 'nequi') {
            if (pay.nequi.celular) {
                parametrosPeticion.pay_celular = pay.nequi.celular;
            }
        }

        if (parametrosPeticion.comprobante_pay === 'aquahabiente') {
            parametrosPeticion.autor_codigo = pay.aquahabiente.cuenta;
            parametrosPeticion.autor_clave = pay.aquahabiente.clave;
        }

        console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('comprobante_pay', parametrosPeticion.comprobante_pay);
            this.httpHeaders = this.httpHeaders.append('encriptado_pay', parametrosPeticion.encriptado);

            if (parametrosPeticion.s_contenedor1 && parametrosPeticion.s_contenedor1_cantidad) {
                this.httpHeaders = this.httpHeaders.append('s_contenedor1', parametrosPeticion.s_contenedor1);
                this.httpHeaders = this.httpHeaders.append('s_contenedor1_cantidad', parametrosPeticion.s_contenedor1_cantidad);
            }

            if (parametrosPeticion.s_contenedor2 && parametrosPeticion.s_contenedor2_cantidad) {
                this.httpHeaders = this.httpHeaders.append('s_contenedor2', parametrosPeticion.s_contenedor2);
                this.httpHeaders = this.httpHeaders.append('s_contenedor2_cantidad', parametrosPeticion.s_contenedor2_cantidad);
            }

            if (parametrosPeticion.s_contenedor3 && parametrosPeticion.s_contenedor3_cantidad) {
                this.httpHeaders = this.httpHeaders.append('s_contenedor3', parametrosPeticion.s_contenedor3);
                this.httpHeaders = this.httpHeaders.append('s_contenedor3_cantidad', parametrosPeticion.s_contenedor3_cantidad);
            }

            if (parametrosPeticion.s_contenedor4 && parametrosPeticion.s_contenedor4_cantidad) {
                this.httpHeaders = this.httpHeaders.append('s_contenedor4', parametrosPeticion.s_contenedor4);
                this.httpHeaders = this.httpHeaders.append('s_contenedor4_cantidad', parametrosPeticion.s_contenedor4_cantidad);
            }

            if (parametrosPeticion.s_contenedor5 && parametrosPeticion.s_contenedor5_cantidad) {
                this.httpHeaders = this.httpHeaders.append('s_contenedor5', parametrosPeticion.s_contenedor5);
                this.httpHeaders = this.httpHeaders.append('s_contenedor5_cantidad', parametrosPeticion.s_contenedor5_cantidad);
            }

            if (parametrosPeticion.s_contenedor6 && parametrosPeticion.s_contenedor6_cantidad) {
                this.httpHeaders = this.httpHeaders.append('s_contenedor6', parametrosPeticion.s_contenedor6);
                this.httpHeaders = this.httpHeaders.append('s_contenedor6_cantidad', parametrosPeticion.s_contenedor6_cantidad);
            }

            if (parametrosPeticion.comprobante_pay === 'nequi') {
                if (parametrosPeticion.pay_celular) {
                    this.httpHeaders = this.httpHeaders.append('pay_celular', parametrosPeticion.pay_celular);
                }
            }

            if (parametrosPeticion.comprobante_pay === 'aquahabiente') {
                this.httpHeaders = this.httpHeaders.append('autor_codigo', parametrosPeticion.autor_codigo);
                this.httpHeaders = this.httpHeaders.append('autor_clave', parametrosPeticion.autor_clave);
            }

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Auth, Iniciar sesión en Refill vending: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> Sistema empresa ID');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }


    async refillEditarSubProceso(dispositivo_id: string, proceso: any) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_refill/getEditarSubProcesoRefill' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id,
            proceso_id: proceso.id,
            proceso_data: proceso.data,
            proceso_aux_data: proceso.aux_data,
            proceso_estado: proceso.estado,
            proceso_temporal: proceso.temporal,
            proceso_autor_app: proceso.autor_app,
            proceso_autor_sistema: proceso.autor_sistema
        }

        console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('proceso_id', parametrosPeticion.proceso_id);
            this.httpHeaders = this.httpHeaders.append('proceso_data', parametrosPeticion.proceso_data);
            this.httpHeaders = this.httpHeaders.append('proceso_aux_data', parametrosPeticion.proceso_aux_data);
            this.httpHeaders = this.httpHeaders.append('proceso_estado', parametrosPeticion.proceso_estado);
            this.httpHeaders = this.httpHeaders.append('proceso_temporal', parametrosPeticion.proceso_temporal);
            this.httpHeaders = this.httpHeaders.append('proceso_autor_app', parametrosPeticion.proceso_autor_app);
            this.httpHeaders = this.httpHeaders.append('proceso_autor_sistema', parametrosPeticion.proceso_autor_sistema);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Refill, Editar Sub proceso: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> Sistema empresa ID');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }


    async refillFinalizarProceso(dispositivo_id: string, pedido: any) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_refill/getConfirmarProcesoRefill' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id,
            pedido_id: pedido.pid
        }

        console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('pedido_id', parametrosPeticion.pedido_id);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Refill, Finalizar de proceso: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> Sistema empresa ID');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }


    /*
    ***********************
   LINEA DE LLENADO
    **********************
    */

    async getLineallenadoPedidosCola(dispositivo_id: string) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando Pedidos...',
            spinner: 'crescent',
            showBackdrop: true
        });
        //loading.present();

        const apiPath = this.apiUrl + '/redatwater_lineallenado/getLineallenadoPedidosCola' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id
        }

        console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Pedidos en cola: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData?.channel_app[0]) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> ');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    // loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }

    async getAddPedidoLineallenado(dispositivo_id: any, servicio: any, proceso: any) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_lineallenado/getAddPedidoLineallenado' + this.peticionDatosAPI;
        const parametrosPeticion: any = {
            dispositivo_id: dispositivo_id,
            encriptado: proceso.encriptado,
            codigo_aquahabiente: proceso.codigo_aquahabiente,
            cantidad_lotes: proceso.cantidad_lotes,
            lote_unidades: proceso.lote_unidades,
            lote_unidad_litros: proceso.lote_unidad_litros,
            servicio_extra: proceso.servicio_extra,
            cantidad_boquillas: proceso.cantidad_boquillas,
            auto: proceso.auto,
            servicio_id: servicio.id
        }

        console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('encriptado', parametrosPeticion.encriptado);
            this.httpHeaders = this.httpHeaders.append('cantidad_boquillas', parametrosPeticion.cantidad_boquillas);
            this.httpHeaders = this.httpHeaders.append('codigo_aquahabiente', parametrosPeticion.codigo_aquahabiente);
            this.httpHeaders = this.httpHeaders.append('cantidad_lotes', parametrosPeticion.cantidad_lotes);
            this.httpHeaders = this.httpHeaders.append('lote_unidades', parametrosPeticion.lote_unidades);
            this.httpHeaders = this.httpHeaders.append('lote_unidad_litros', parametrosPeticion.lote_unidad_litros);
            this.httpHeaders = this.httpHeaders.append('servicio_extra', parametrosPeticion.servicio_extra);
            this.httpHeaders = this.httpHeaders.append('auto', parametrosPeticion.auto);
            this.httpHeaders = this.httpHeaders.append('servicio_id', parametrosPeticion.servicio_id);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Linea de llenado, Proceso de dispensado de agua: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> Sistema empresa ID');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }


    async getEditarSubProcesoLineallenado(dispositivo_id: string, proceso: any) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_lineallenado/getEditarSubProcesoLineallenado' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id,
            proceso_id: proceso.id,
            proceso_data: proceso.data,
            proceso_aux_data: proceso.aux_data,
            proceso_estado: proceso.estado,
            proceso_temporal: proceso.temporal,
            proceso_autor_app: proceso.autor_app,
            proceso_autor_sistema: proceso.autor_sistema
        }

        console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('proceso_id', parametrosPeticion.proceso_id);
            this.httpHeaders = this.httpHeaders.append('proceso_data', parametrosPeticion.proceso_data);
            this.httpHeaders = this.httpHeaders.append('proceso_aux_data', parametrosPeticion.proceso_aux_data);
            this.httpHeaders = this.httpHeaders.append('proceso_estado', parametrosPeticion.proceso_estado);
            this.httpHeaders = this.httpHeaders.append('proceso_temporal', parametrosPeticion.proceso_temporal);
            this.httpHeaders = this.httpHeaders.append('proceso_autor_app', parametrosPeticion.proceso_autor_app);
            this.httpHeaders = this.httpHeaders.append('proceso_autor_sistema', parametrosPeticion.proceso_autor_sistema);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Linea de llenado, Editar Sub proceso: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> Sistema empresa ID');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }


    async getFinalizarLineallenado(dispositivo_id: string, pedido: any) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_lineallenado/getConfirmarProcesoLineallenado' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id,
            pedido_id: pedido.pid
        }

        console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('pedido_id', parametrosPeticion.pedido_id);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Linea de llenado, Finalizar de proceso: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> Sistema empresa ID');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }

    /*
  ***********************
 AT CLEANING
  **********************
  */

    async getCleaningPedidosCola(dispositivo_id: string) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando Pedidos...',
            spinner: 'crescent',
            showBackdrop: true
        });
        //loading.present();

        const apiPath = this.apiUrl + '/redatwater_atcleaning/getCleaningPedidosCola' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id
        }

        console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Pedidos en cola: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData?.channel_app[0]) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> ');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    // loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }

    async getAddPedidoCleaning(dispositivo_id: any, pay: any, dispensado1?: any, dispensado2?: any, dispensado3?: any, dispensado4?: any, dispensado5?: any, dispensado6?: any) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_atcleaning/getAddPedidoCleaning' + this.peticionDatosAPI;
        const parametrosPeticion: any = {
            dispositivo_id: dispositivo_id,
            comprobante_pay: pay.metodo,
            encriptado: pay.encriptado,
            s_dispensado1: dispensado1.id,
            s_dispensado1_litros: dispensado1.litros,
            s_dispensado2: dispensado2.id,
            s_dispensado2_litros: dispensado2.litros,
            s_dispensado3: dispensado3.id,
            s_dispensado3_litros: dispensado3.litros,
            s_dispensado4: dispensado4.id,
            s_dispensado4_litros: dispensado4.litros,
            s_dispensado5: dispensado5.id,
            s_dispensado5_litros: dispensado5.litros,
            s_dispensado6: dispensado6.id,
            s_dispensado6_litros: dispensado6.litros
        }


        if (parametrosPeticion.comprobante_pay === 'nequi') {
            if (pay.nequi.celular) {
                parametrosPeticion.pay_celular = pay.nequi.celular;
            }
        }

        if (parametrosPeticion.comprobante_pay === 'aquahabiente') {
            parametrosPeticion.autor_codigo = pay.aquahabiente.cuenta;
            parametrosPeticion.autor_clave = pay.aquahabiente.clave;
        }

        console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('comprobante_pay', parametrosPeticion.comprobante_pay);
            this.httpHeaders = this.httpHeaders.append('encriptado_pay', parametrosPeticion.encriptado);

            if (parametrosPeticion.s_dispensado1 && parametrosPeticion.s_dispensado1_litros) {
                this.httpHeaders = this.httpHeaders.append('s_dispensado1', parametrosPeticion.s_dispensado1);
                this.httpHeaders = this.httpHeaders.append('s_dispensado1_litros', parametrosPeticion.s_dispensado1_litros);
            }

            if (parametrosPeticion.s_dispensado2 && parametrosPeticion.s_dispensado2_litros) {
                this.httpHeaders = this.httpHeaders.append('s_dispensado2', parametrosPeticion.s_dispensado2);
                this.httpHeaders = this.httpHeaders.append('s_dispensado2_litros', parametrosPeticion.s_dispensado2_litros);
            }

            if (parametrosPeticion.s_dispensado3 && parametrosPeticion.s_dispensado3_litros) {
                this.httpHeaders = this.httpHeaders.append('s_dispensado3', parametrosPeticion.s_dispensado3);
                this.httpHeaders = this.httpHeaders.append('s_dispensado3_litros', parametrosPeticion.s_dispensado3_litros);
            }

            if (parametrosPeticion.s_dispensado4 && parametrosPeticion.s_dispensado4_litros) {
                this.httpHeaders = this.httpHeaders.append('s_dispensado4', parametrosPeticion.s_dispensado4);
                this.httpHeaders = this.httpHeaders.append('s_dispensado4_litros', parametrosPeticion.s_dispensado4_litros);
            }

            if (parametrosPeticion.s_dispensado5 && parametrosPeticion.s_dispensado5_litros) {
                this.httpHeaders = this.httpHeaders.append('s_dispensado5', parametrosPeticion.s_dispensado5);
                this.httpHeaders = this.httpHeaders.append('s_dispensado5_litros', parametrosPeticion.s_dispensado5_litros);
            }

            if (parametrosPeticion.s_dispensado6 && parametrosPeticion.s_dispensado6_litros) {
                this.httpHeaders = this.httpHeaders.append('s_dispensado6', parametrosPeticion.s_dispensado6);
                this.httpHeaders = this.httpHeaders.append('s_dispensado6_litros', parametrosPeticion.s_dispensado6_litros);
            }

            if (parametrosPeticion.comprobante_pay === 'nequi') {
                if (parametrosPeticion.pay_celular) {
                    this.httpHeaders = this.httpHeaders.append('pay_celular', parametrosPeticion.pay_celular);
                }
            }

            if (parametrosPeticion.comprobante_pay === 'aquahabiente') {
                this.httpHeaders = this.httpHeaders.append('autor_codigo', parametrosPeticion.autor_codigo);
                this.httpHeaders = this.httpHeaders.append('autor_clave', parametrosPeticion.autor_clave);
            }
            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> At Cleaning, Proceso de dispensado de liquido de aseo: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> Sistema empresa ID');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }


    async getEditarSubProcesoCleaning(dispositivo_id: string, proceso: any) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_atcleaning/getEditarSubProcesoCleaning' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id,
            proceso_id: proceso.id,
            proceso_data: proceso.data,
            proceso_aux_data: proceso.aux_data,
            proceso_estado: proceso.estado,
            proceso_temporal: proceso.temporal,
            proceso_autor_app: proceso.autor_app,
            proceso_autor_sistema: proceso.autor_sistema
        }

        console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('proceso_id', parametrosPeticion.proceso_id);
            this.httpHeaders = this.httpHeaders.append('proceso_data', parametrosPeticion.proceso_data);
            this.httpHeaders = this.httpHeaders.append('proceso_aux_data', parametrosPeticion.proceso_aux_data);
            this.httpHeaders = this.httpHeaders.append('proceso_estado', parametrosPeticion.proceso_estado);
            this.httpHeaders = this.httpHeaders.append('proceso_temporal', parametrosPeticion.proceso_temporal);
            this.httpHeaders = this.httpHeaders.append('proceso_autor_app', parametrosPeticion.proceso_autor_app);
            this.httpHeaders = this.httpHeaders.append('proceso_autor_sistema', parametrosPeticion.proceso_autor_sistema);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> At Cleaning, Editar Sub proceso: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> Sistema empresa ID');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }


    async getFinalizarCleaning(dispositivo_id: string, pedido: any) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_atcleaning/getConfirmarProcesoCleaning' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id,
            pedido_id: pedido.pid
        }

        console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('pedido_id', parametrosPeticion.pedido_id);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> At Cleaning, Finalizar de proceso: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> Sistema empresa ID');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }


    /*
***********************
AT MILK
**********************
*/

    async getMilkPedidosCola(dispositivo_id: string) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando Pedidos...',
            spinner: 'crescent',
            showBackdrop: true
        });
        //loading.present();

        const apiPath = this.apiUrl + '/redatwater_atmilk/getMilkPedidosCola' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id
        }

        console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Pedidos en cola: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData?.channel_app[0]) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> ');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    // loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }

    async getAddPedidoMilk(dispositivo_id: any, pay: any, dispensado1?: any, dispensado2?: any, dispensado3?: any) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_atmilk/getAddPedidoMilk' + this.peticionDatosAPI;
        const parametrosPeticion: any = {
            dispositivo_id: dispositivo_id,
            comprobante_pay: pay.metodo,
            encriptado: pay.encriptado,
            s_dispensado1: dispensado1.id,
            s_dispensado1_litros: dispensado1.litros,
            s_dispensado2: dispensado2.id,
            s_dispensado2_litros: dispensado2.litros,
            s_dispensado3: dispensado3.id,
            s_dispensado3_litros: dispensado3.litros
        }


        if (parametrosPeticion.comprobante_pay === 'nequi') {
            if (pay.nequi.celular) {
                parametrosPeticion.pay_celular = pay.nequi.celular;
            }
        }

        if (parametrosPeticion.comprobante_pay === 'aquahabiente') {
            parametrosPeticion.autor_codigo = pay.aquahabiente.cuenta;
            parametrosPeticion.autor_clave = pay.aquahabiente.clave;
        }

        console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('comprobante_pay', parametrosPeticion.comprobante_pay);
            this.httpHeaders = this.httpHeaders.append('encriptado_pay', parametrosPeticion.encriptado);

            if (parametrosPeticion.s_dispensado1 && parametrosPeticion.s_dispensado1_litros) {
                this.httpHeaders = this.httpHeaders.append('s_dispensado1', parametrosPeticion.s_dispensado1);
                this.httpHeaders = this.httpHeaders.append('s_dispensado1_litros', parametrosPeticion.s_dispensado1_litros);
            }

            if (parametrosPeticion.s_dispensado2 && parametrosPeticion.s_dispensado2_litros) {
                this.httpHeaders = this.httpHeaders.append('s_dispensado2', parametrosPeticion.s_dispensado2);
                this.httpHeaders = this.httpHeaders.append('s_dispensado2_litros', parametrosPeticion.s_dispensado2_litros);
            }

            if (parametrosPeticion.s_dispensado3 && parametrosPeticion.s_dispensado3_litros) {
                this.httpHeaders = this.httpHeaders.append('s_dispensado3', parametrosPeticion.s_dispensado3);
                this.httpHeaders = this.httpHeaders.append('s_dispensado3_litros', parametrosPeticion.s_dispensado3_litros);
            }

            if (parametrosPeticion.comprobante_pay === 'nequi') {
                if (parametrosPeticion.pay_celular) {
                    this.httpHeaders = this.httpHeaders.append('pay_celular', parametrosPeticion.pay_celular);
                }
            }

            if (parametrosPeticion.comprobante_pay === 'aquahabiente') {
                this.httpHeaders = this.httpHeaders.append('autor_codigo', parametrosPeticion.autor_codigo);
                this.httpHeaders = this.httpHeaders.append('autor_clave', parametrosPeticion.autor_clave);
            }
            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> At Milk, Proceso de dispensado: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> Sistema empresa ID');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }


    async getEditarSubProcesoMilk(dispositivo_id: string, proceso: any) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_atmilk/getEditarSubProcesoMilk' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id,
            proceso_id: proceso.id,
            proceso_data: proceso.data,
            proceso_aux_data: proceso.aux_data,
            proceso_estado: proceso.estado,
            proceso_temporal: proceso.temporal,
            proceso_autor_app: proceso.autor_app,
            proceso_autor_sistema: proceso.autor_sistema
        }

        console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('proceso_id', parametrosPeticion.proceso_id);
            this.httpHeaders = this.httpHeaders.append('proceso_data', parametrosPeticion.proceso_data);
            this.httpHeaders = this.httpHeaders.append('proceso_aux_data', parametrosPeticion.proceso_aux_data);
            this.httpHeaders = this.httpHeaders.append('proceso_estado', parametrosPeticion.proceso_estado);
            this.httpHeaders = this.httpHeaders.append('proceso_temporal', parametrosPeticion.proceso_temporal);
            this.httpHeaders = this.httpHeaders.append('proceso_autor_app', parametrosPeticion.proceso_autor_app);
            this.httpHeaders = this.httpHeaders.append('proceso_autor_sistema', parametrosPeticion.proceso_autor_sistema);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> At Milk, Editar Sub proceso: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> Sistema empresa ID');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }


    async getFinalizarMilk(dispositivo_id: string, pedido: any) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_atmilk/getConfirmarProcesoMilk' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id,
            pedido_id: pedido.pid
        }

        console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('pedido_id', parametrosPeticion.pedido_id);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> At Milk, Finalizar de proceso: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> Sistema empresa ID');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }


    /*
***********************
AT OIL
**********************
*/

    async getOilPedidosCola(dispositivo_id: string) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando Pedidos...',
            spinner: 'crescent',
            showBackdrop: true
        });
        //loading.present();

        const apiPath = this.apiUrl + '/redatwater_atoil/getOilPedidosCola' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id
        }

        console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Pedidos en cola: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData?.channel_app[0]) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> ');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    // loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }

    async getAddPedidoOil(dispositivo_id: any, pay: any, dispensado1?: any, dispensado2?: any, dispensado3?: any) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_atoil/getAddPedidoOil' + this.peticionDatosAPI;
        const parametrosPeticion: any = {
            dispositivo_id: dispositivo_id,
            comprobante_pay: pay.metodo,
            encriptado: pay.encriptado,
            s_dispensado1: dispensado1.id,
            s_dispensado1_litros: dispensado1.litros,
            s_dispensado2: dispensado2.id,
            s_dispensado2_litros: dispensado2.litros,
            s_dispensado3: dispensado3.id,
            s_dispensado3_litros: dispensado3.litros
        }


        if (parametrosPeticion.comprobante_pay === 'nequi') {
            if (pay.nequi.celular) {
                parametrosPeticion.pay_celular = pay.nequi.celular;
            }
        }

        if (parametrosPeticion.comprobante_pay === 'aquahabiente') {
            parametrosPeticion.autor_codigo = pay.aquahabiente.cuenta;
            parametrosPeticion.autor_clave = pay.aquahabiente.clave;
        }

        console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('comprobante_pay', parametrosPeticion.comprobante_pay);
            this.httpHeaders = this.httpHeaders.append('encriptado_pay', parametrosPeticion.encriptado);

            if (parametrosPeticion.s_dispensado1 && parametrosPeticion.s_dispensado1_litros) {
                this.httpHeaders = this.httpHeaders.append('s_dispensado1', parametrosPeticion.s_dispensado1);
                this.httpHeaders = this.httpHeaders.append('s_dispensado1_litros', parametrosPeticion.s_dispensado1_litros);
            }

            if (parametrosPeticion.s_dispensado2 && parametrosPeticion.s_dispensado2_litros) {
                this.httpHeaders = this.httpHeaders.append('s_dispensado2', parametrosPeticion.s_dispensado2);
                this.httpHeaders = this.httpHeaders.append('s_dispensado2_litros', parametrosPeticion.s_dispensado2_litros);
            }

            if (parametrosPeticion.s_dispensado3 && parametrosPeticion.s_dispensado3_litros) {
                this.httpHeaders = this.httpHeaders.append('s_dispensado3', parametrosPeticion.s_dispensado3);
                this.httpHeaders = this.httpHeaders.append('s_dispensado3_litros', parametrosPeticion.s_dispensado3_litros);
            }

            if (parametrosPeticion.comprobante_pay === 'nequi') {
                if (parametrosPeticion.pay_celular) {
                    this.httpHeaders = this.httpHeaders.append('pay_celular', parametrosPeticion.pay_celular);
                }
            }

            if (parametrosPeticion.comprobante_pay === 'aquahabiente') {
                this.httpHeaders = this.httpHeaders.append('autor_codigo', parametrosPeticion.autor_codigo);
                this.httpHeaders = this.httpHeaders.append('autor_clave', parametrosPeticion.autor_clave);
            }
            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> At Oil, Proceso de dispensado: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> Sistema empresa ID');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }


    async getEditarSubProcesoOil(dispositivo_id: string, proceso: any) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_atoil/getEditarSubProcesoOil' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id,
            proceso_id: proceso.id,
            proceso_data: proceso.data,
            proceso_aux_data: proceso.aux_data,
            proceso_estado: proceso.estado,
            proceso_temporal: proceso.temporal,
            proceso_autor_app: proceso.autor_app,
            proceso_autor_sistema: proceso.autor_sistema
        }

        console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('proceso_id', parametrosPeticion.proceso_id);
            this.httpHeaders = this.httpHeaders.append('proceso_data', parametrosPeticion.proceso_data);
            this.httpHeaders = this.httpHeaders.append('proceso_aux_data', parametrosPeticion.proceso_aux_data);
            this.httpHeaders = this.httpHeaders.append('proceso_estado', parametrosPeticion.proceso_estado);
            this.httpHeaders = this.httpHeaders.append('proceso_temporal', parametrosPeticion.proceso_temporal);
            this.httpHeaders = this.httpHeaders.append('proceso_autor_app', parametrosPeticion.proceso_autor_app);
            this.httpHeaders = this.httpHeaders.append('proceso_autor_sistema', parametrosPeticion.proceso_autor_sistema);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> At Oil, Editar Sub proceso: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> Sistema empresa ID');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }


    async getFinalizarOil(dispositivo_id: string, pedido: any) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater_atoil/getConfirmarProcesoOil' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: dispositivo_id,
            pedido_id: pedido.pid
        }

        console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('pedido_id', parametrosPeticion.pedido_id);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> At Oil, Finalizar de proceso: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }
                        if (getData?.channel.conexion_token) {
                            if (getData.channel_app[0]?.channel_sistema.empresa_id) {

                                resolve(getData);
                            } else {

                                resolve(false);
                                console.log('Seguimiento de errores -> Sistema empresa ID');
                            }
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                    resolve(false);
                })
            );

        });
    }

    // VERIFICAR DOCUMENTO, MODULOS DISPONIBLES
    async verificarModulosDisponibles(codigo: any) {
        const loading = await this.loadingCtrl.create({
            message: 'Verificando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        const apiPath = this.apiUrl + '/redatwater/documento_modulos' + this.peticionDatosAPI;
        const parametrosPeticion = {
            documento: codigo,
        }

        console.log('Data -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('documento', parametrosPeticion.documento);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Auth, Verificar documentos y modulos disponibles: ', getData);

                    if (getData?.data) {
                        console.log('Seguimiento data -> ', getData);
                        resolve(getData.data);
                    } else {
                        resolve(false);
                    }

                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                })
            );

        });
    }

    /* VERIFICAR PROCESOS DE AQUABOT */
    /*
    async verificarProcesosAquabot() {
        const apiPath = this.apiUrl + '/redatwater_aquabot/procesos_aquabot' + this.peticionDatosAPI;

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            //this.httpHeaders = this.httpHeaders.append('modulo', parametrosPeticion.modulo);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    console.log('Peticion -> Aquabot en Dispositivo: ', getData);

                    if (getData) {
                        if (getData.respuesta?.messages) {
                            this.setChannelMessages(getData.respuesta?.messages);
                        }
                        if (getData.respuesta?.channel.conexion_token) {
                            reject(getData.aquabot);
                        } else {
                            resolve(false);
                        }
                        console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }



                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);

                })
            );

        });
    }
    */

    // GUARDAR TOKEN DE DISPOSITIVO ACTUAL
    async guardarTokenNotificacion(token: any, dispositivo: any, dispositivo_id: any): Promise<any> {

        return new Promise((resolve, reject) => {
            const apiPath = this.apiUrl + '/redatwater/tokenNotificacionApp' + this.peticionDatosAPI + '&token=' + JSON.stringify(token) + '&dispositivo_id=' + dispositivo_id + '&movil=' + dispositivo;
            //console.log('Peticion notificacion, ', apiPath);
            const checkToken = this.subscriptionHttp.add(
                this.http.get(apiPath).subscribe((data: any) => {

                    if (data) {

                        if (data.respuesta.data.msg) {
                            const messages = data.respuesta.data.msg;
                            this.setChannelMessages(messages);
                            this.toast.msgAppMultiple(messages, 'bottom');
                        }

                        if (data.respuesta.data.cuenta) {

                            resolve(data.respuesta.data.cuenta);

                        } else {
                            resolve(false);
                        }
                    }


                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                })
            );


        });

    }

    // Temas de interes Full / Blog
    //https://api.bancodelagua.com/channel/redatwater/getInteresFullPublicaciones?pass=&empresa=&pais=
    async consultarTemasInteresFull(busqueda?: any): Promise<any> {
        const loading = await this.loadingCtrl.create({
            message: 'Cargando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        return new Promise((resolve, reject) => {

            const apiPath = this.apiUrl + '/redatwater/getInteresFullPublicaciones' + this.peticionDatosAPI;
            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('bus', busqueda);

            const listaTemas = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((data: any) => {
                    //console.log('Peticion -> Full Temas de Interes: ', data);

                    if (data) {
                        if (data.respuesta.data.msg) {
                            const messages = data.respuesta.data.msg;
                            this.setChannelMessages(messages);
                            //this.toast.msgAppMultiple(messages, 'bottom');
                        }
                        if (data.respuesta.data?.interes) {

                            resolve(data.respuesta.data.interes);

                        } else {
                            resolve(false);
                        }
                    }
                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                })
            );

        });
    }

    // ENVIAR MENSAJE POR CORREO EMPRESA
    //https://api.bancodelagua.com/channel/redatwater/sendEmailContactoEmpresa?pass=&empresa=&pais=
    async sendCorreoEmpresa(empresa_id: any, motivo: string, nombre: string, codigo: string, modulo: string): Promise<any> {
        const loading = await this.loadingCtrl.create({
            message: 'Cargando...',
            spinner: 'crescent',
            showBackdrop: true
        });
        loading.present();

        return new Promise((resolve, reject) => {

            const apiPath = this.apiUrl + '/redatwater/sendEmailContactoEmpresa' + this.peticionDatosAPI;
            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('empresa_id', empresa_id);
            this.httpHeaders = this.httpHeaders.append('motivo', motivo);
            this.httpHeaders = this.httpHeaders.append('nombre', nombre);
            this.httpHeaders = this.httpHeaders.append('codigo', codigo);
            this.httpHeaders = this.httpHeaders.append('modulo', modulo);

            const empresaContacto = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((data: any) => {
                    //console.log('Peticion -> Send Correo Contacto Empresa: ', data);

                    if (data) {
                        if (data?.message) {
                            const messages = data?.message;
                            this.setChannelMessages(messages);
                            //this.toast.msgAppMultiple(messages, 'bottom');
                        }
                        if (data.data?.send_msg) {

                            resolve(data.data.send_msg);

                        } else {
                            resolve(false);
                        }
                    }
                    loading.dismiss();

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);
                    loading.dismiss();
                })
            );

        });
    }

    // CONSULTAR PROCESOS AQUABOT
    async procesosAquabotChannel(id: string) {

        const apiPath = this.apiUrl + '/redatwater/p_aquabot' + this.peticionDatosAPI;
        const parametrosPeticion = {
            dispositivo_id: id
        }

        //console.log('Data procesos aquabot -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    //console.log('Peticion -> Procesos Aquabot: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }

                        if (getData?.data.aquabot) {
                            resolve(getData.data);
                        } else {
                            resolve(false);
                        }

                        // console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);

                })
            );

        });

    }



    // FINALIZAR PROCESO AQUABOT 
    async procesosFinalizarAquabotChannel(id: string, dispositivo_id: string) {


        const apiPath = this.apiUrl + '/redatwater/f_p_aquabot' + this.peticionDatosAPI;
        const parametrosPeticion = {
            id: id,
            dispositivo_id: dispositivo_id
        }

        //  console.log('Data finalizar procesos aquabot -> ' + parametrosPeticion);

        return new Promise((resolve, reject) => {

            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('dispositivo_id', parametrosPeticion.dispositivo_id);
            this.httpHeaders = this.httpHeaders.append('id', parametrosPeticion.id);

            const peticionAuth = this.subscriptionHttp.add(
                this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                    //  console.log('Peticion -> Procesos finalizados Aquabot: ', getData);

                    if (getData) {
                        if (getData?.messages) {
                            this.setChannelMessages(getData?.messages);
                        }

                        if (getData?.data.aquabot) {
                            resolve(getData.data);
                        } else {
                            resolve(false);
                        }

                        // console.log('Seguimiento -> ', getData.messages);
                    } else {
                        resolve(false);
                    }

                }, (err: any) => {
                    console.log('Seguimiento de errores -> HTTP: ', err);

                })
            );

        });

    }

    async aquabotPosicionamiento(titulo: string, web_url: string): Promise<any> {

        try {
            // Corrección y validación de URL
            web_url = this.normalizeUrl(web_url);
            if (!web_url) {
                throw new Error('URL inválida. Verifica la dirección proporcionada.');
            }

            const apiPath = `${web_url}/`;
            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('titulo', titulo);

            return new Promise((resolve, reject) => {
                const peticionAuth = this.subscriptionHttp.add(
                    this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                        // console.log('Peticion -> Procesos Aquabot: ', getData);

                        if (getData) {
                            if (getData?.messages) {
                                this.setChannelMessages(getData?.messages);
                            }

                            if (getData?.data.aquabot) {
                                resolve(getData.data);
                            } else {
                                resolve(false);
                            }

                            //  console.log('Seguimiento -> ', getData.messages);
                        } else {
                            resolve(false);
                        }



                    }, (err: any) => {
                        console.log('Seguimiento de errores -> HTTP: ', err);

                    })
                );
            });

        } catch (error) {
            console.error('Error en aquabotPosicionamiento:', error);
            return false;

        } finally {

        }
    }

    async aquabotAtaque(titulo: string, web_url: string): Promise<any> {

        try {
            // Corrección y validación de URL
            web_url = this.normalizeUrl(web_url);
            if (!web_url) {
                throw new Error('URL inválida. Verifica la dirección proporcionada.');
            }

            const apiPath = `${web_url}/`;
            this.httpHeaders = new HttpParams();
            this.httpHeaders = this.httpHeaders.append('titulo', titulo);

            return new Promise((resolve, reject) => {
                const peticionAuth = this.subscriptionHttp.add(
                    this.http.get(apiPath, { params: this.httpHeaders }).subscribe((getData: any) => {

                        // console.log('Peticion -> Procesos Aquabot: ', getData);

                        if (getData) {
                            if (getData?.messages) {
                                this.setChannelMessages(getData?.messages);
                            }

                            if (getData?.data.aquabot) {
                                resolve(getData.data);
                            } else {
                                resolve(false);
                            }

                            // console.log('Seguimiento -> ', getData.messages);
                        } else {
                            resolve(false);
                        }

                    }, (err: any) => {
                        console.log('Seguimiento de errores -> HTTP: ', err);

                    })
                );
            });

        } catch (error) {
            console.error('Error en aquabotPosicionamiento:', error);
            return false;

        } finally {

        }
    }

    /**
     * Normaliza la URL corrigiendo errores comunes.
     */
    private normalizeUrl(url: string): string | null {
        try {
            url = url.trim();

            // Agregar esquema si no lo tiene
            if (!/^https?:\/\//i.test(url)) {
                url = `https://${url}`;
            }

            const parsedUrl = new URL(url);

            // Si solo tiene dominio sin www, corregir si es necesario
            if (!parsedUrl.hostname.includes('.')) {
                return null; // URL inválida
            }

            return parsedUrl.toString();
        } catch (e) {
            return null; // URL inválida
        }
    }


}
